import type { PortfolioAnalyticsPropertyResponseDto } from '@zg-rentals/ts-customer-analytics-client';

export const isAllSingleFamily = (filteredProperties: Array<PortfolioAnalyticsPropertyResponseDto>): boolean =>
  filteredProperties.every((property) => property.aggregateStats.isSingleFamily) && filteredProperties.length > 0;
